module.exports = __webpack_public_path__ + "img/icon-zalo.2ea9241b.svg";